$(document).ready(function () {
    $(document).on("click", ".styledRadiobuttonWrapper:not(.disabled, .vue)", function () {
        $(this).find(".styledRadiobutton").trigger("click");
        $(this).find(".zbr-radiobutton[data-type='styledRadiobutton']").trigger("click");
    });

    $(document).on("click", ".styledRadiobutton:not(.disabled, .vue)", function (e) {
        e.stopPropagation();

        // Reset (unclick) all styled radio inputs with the same name, then select the clicked radiobutton and its hidden input
        if (!$(this).hasClass("selected")) {
            var name = $(this).attr("data-name");
            $(".styledRadiobutton[data-name='" + name + "']").removeClass("selected");
            $(".styledRadiobutton[data-name='" + name + "'] + input").attr("checked", false);
            $(this).next().attr("checked", true);
            $(this).addClass("selected");
            $.event.trigger("styledRadiobuttonChanged", [name, $(this).next().val(), $(this)]);
        }

        return false;
    });

    $(document).on("click", ".zbr-radiobutton[data-type='styledRadiobutton']:not(.disabled)", function (e) {
        e.stopPropagation();
        
        // Reset (unclick) all styled radio inputs with the same name, then select the clicked radiobutton and its hidden input
        if (!$(this).hasClass("zbr-radiobutton--checked")) {
            var name = $(this).attr("data-name");
            
            $(".zbr-radiobutton[data-type='styledRadiobutton'][data-name='" + name + "']").removeClass("zbr-radiobutton--checked");
            $(".zbr-radiobutton[data-type='styledRadiobutton'][data-name='" + name + "'] + input").attr("checked", false);
            $(this).next().attr("checked", true);
            $(this).addClass("zbr-radiobutton--checked");
            $.event.trigger("styledRadiobuttonChanged", [name, $(this).next().val(), $(this)]);
        }

        return false;
    });
});